export const PI_2 = Math.PI * 2;
export const PI_HALF = Math.PI / 2;
